module.exports = __webpack_public_path__ + "img/login_bg.41b8faa5.jpg";